import { memo, useState } from "react";
import type { Node, NodeProps } from "@xyflow/react";
import { NodeResizer, useReactFlow } from "@xyflow/react";
import "./lappeplan.css";

export type ImageNodeData = { path: string };
type ImageNode = Node<ImageNodeData, "image">;

const LappeplanImage: React.FC<NodeProps<ImageNode>> = ({ id, width, height, data, selected }) => {
  const { deleteElements } = useReactFlow();
  const [hovered, setHovered] = useState(false);

  const w = typeof width === "number" ? width : 200;
  const h = typeof height === "number" ? height : 150;

  return (
    <>
      <NodeResizer
        minWidth={100}
        minHeight={100}
        /* <-- synlig på hover eller när vald */
        isVisible={hovered || !!selected}
        /* gör hörnen lite större + över allt annat */
        handleStyle={{
          zIndex: 15,
          width: 10,
          height: 10,
          borderRadius: 2,
          border: "2px solid #1b76d1",
          background: "#fff",
        }}
        lineStyle={{ zIndex: 14, stroke: "#1b76d1", strokeWidth: 1 }}
      />

      <div
        className="image-node-container"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          position: "relative",
          width: w,
          height: h,
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          border: "2px solid #ddd",
          overflow: "hidden",
          background: "#f2f2f2",
        }}
      >
        <img
          src={data?.path ?? ""}
          alt=""
          draggable={false}
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            display: "block",
            zIndex: 0,
            pointerEvents: "none",
          }}
        />

        {/* tydlig delete-knapp */}
        <button
          className="image-node-delete"
          onClick={(e) => {
            e.stopPropagation();
            deleteElements({ nodes: [{ id }] });
          }}
          aria-label="Ta bort bild"
          title="Ta bort bild"
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 20,
            width: 28,
            height: 28,
            borderRadius: 9999,
            border: "2px solid #fff",
            background: "#d92f2f",
            color: "#fff",
            cursor: "pointer",
            display: "grid",
            placeItems: "center",
            fontWeight: 800,
            lineHeight: 1,
          }}
        >
          <i className="fa fa-close" />
        </button>
      </div>
    </>
  );
};

export default memo(LappeplanImage);
